<script setup lang="ts">
import { StackLayout } from '@/components/Layouts'
import HomeAnnouncements from './Home/HomeAnnouncements.vue'
</script>

<template>
    <StackLayout direction="column" :gap="16" class="full-width full-height">
        <HomeAnnouncements />
    </StackLayout>
</template>
